"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _slice = require("@lce/slice");

var _i18n = require("@lce/i18n");

var _api = require("@lce/api");

var Styled = _interopRequireWildcard(require("./Handle.style"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var AuthenticatedLabel = function AuthenticatedLabel(_a) {
  var firstName = _a.firstName;
  var t = (0, _i18n.useTranslation)()[0];
  return _react["default"].createElement(_slice.Box, {
    "data-testid": "header__loggedin-my-account-icon"
  }, t('Header.AccountLinks.Greeting') + " " + firstName);
};

var Handle = function Handle() {
  var _a = (0, _api.useAccount)(),
      account = _a.data,
      isLoading = _a.isLoading;

  var isAuthenticated = (0, _api.useAuthenticated)();
  var t = (0, _i18n.useTranslation)()[0];
  return !isLoading ? _react["default"].createElement(Styled.AccountHandle, {
    "data-testid": "header__account"
  }, _react["default"].createElement(_slice.Flex, {
    alignItems: "center"
  }, isAuthenticated && (account === null || account === void 0 ? void 0 : account.firstName) ? _react["default"].createElement(AuthenticatedLabel, {
    firstName: account.firstName
  }) : _react["default"].createElement(_slice.Box, {
    "data-testid": "header__guest-my-account-icon"
  }, t('Header.AccountLinks.Greeting') + " " + t('Header.AccountLinks.Guest')), _react["default"].createElement(Styled.Chevron, {
    size: "12px",
    "stroke-width": "5"
  }))) : null;
};

var _default = Handle;
exports["default"] = _default;